import React from 'react';
import arrow from '../../assets/long-arrow.svg';
import appStore from '../../assets/download-app-store.png';
import heroImage from '../../assets/hero-group-image.png';
import heroImageMobile from '../../assets/hero-image-mobile.png'; // Import the mobile image
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero-section" id='hero'>
      <div className="container">
        <div className="row align-items-center">
          
          {/* Image Column */}
          <div className="col-md-6 col-12 order-1 order-md-2 mb-4 mb-md-0 position-relative">
            <picture>
              {/* Define the mobile image for screens up to 767px */}
              <source media="(max-width: 767px)" srcSet={heroImageMobile} />
              {/* Default image for larger screens */}
              <img className="hero-image" src={heroImage} alt="Hero Group" />
            </picture>
            
            {/* Mobile: Overlaid Text on Image */}
            <div className="image-overlay d-md-none">
              <div className="hero-central-section">
                <h1 className="hero-title-1">Stay hydrated.</h1>
                <div className="hero-title-2-section">
                  <img className="hero-title-2-image" src={arrow} alt="Arrow Icon" />
                  <h2 className="hero-title-2">Meet Commito.</h2>
                </div>
                <p className="hero-central-text">
                  ACHIEVE YOUR GOALS | LOG EVERY SIP | STAY FOCUSED
                </p>
                <p className="hero-central-text">
                  CREATE HEALTHY HABITS | Balance Coffee and Water Intake
                </p>
              </div>
            </div>
          </div>

          {/* Text Column */}
          <div className="col-md-6 col-12 order-2 order-md-1">
            
            {/* Desktop: Text */}
            <div className="desktop-text d-none d-md-block">
              <h1 className="hero-title-1">Stay hydrated.</h1>
              <div className="hero-title-2-section">
                <img className="hero-title-2-image" src={arrow} alt="Arrow Icon" />
                <h2 className="hero-title-2">Meet Commito.</h2>
              </div>
              <div className="hero-central-section">
                <p className="hero-central-text">
                  ACHIEVE YOUR GOALS | LOG EVERY SIP | STAY FOCUSED
                </p>
                <p className="hero-central-text">
                  CREATE HEALTHY HABITS | Balance Coffee and Water Intake
                </p>
              </div>
            </div>

            {/* Mobile: Text Below Image */}
            <div className="mobile-bottom d-md-none">
              <p className="hero-text-1">
                <span className="hero-text-dark">Not drinking enough water?</span> Commito makes it easy to stay hydrated.
                Log your drinks, set daily goals, and see your progress in real-time. It’s a simple way to build better habits and feel more energized every day.
              </p>
              <p className="hero-text-dark">
                Start tracking today <span className="hero-text-bg">for free</span> and feel the difference!
              </p>
              <div className="hero-appstore">
                <a target='_blank' rel='noreferrer' href="https://apps.apple.com/us/app/commito/id6642675101">
                  <img className="hero-appstore-image" src={appStore} alt="Download on App Store" />
                </a>
              </div>
            </div>

            {/* Desktop: Text Below */}
            <div className="desktop-bottom d-none d-md-block">
              <p className="hero-text-1">
                <span className="hero-text-dark">Not drinking enough water?</span> Commito makes it easy to stay hydrated.
                Log your drinks, set daily goals, and see your progress in real-time. It’s a simple way to build better habits and feel more energized every day.
              </p>
              <p className="hero-text-dark">
                Start tracking today <span className="hero-text-bg">for free</span> and feel the difference!
              </p>
              <div className="hero-appstore">
                <a target='_blank' rel='noreferrer' href="https://apps.apple.com/us/app/commito/id6642675101">
                  <img className="hero-appstore-image" src={appStore} alt="Download on App Store" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
